import React, {
  FC,
  useEffect,
  useState,
  // CSSProperties,
  // memo,
  // useCallback,
  // useRef,
  // useEffect,
} from 'react';
import PitBimwinSwitchCheckBox from '../PitBimwinSwitchCheckBox/PitBimwinSwitchCheckBox';
import hideImg from '../../assets/images/hide.png';
import addImg from '../../assets/images/add.png';
import hidehoverImg from '../../assets/images/hidehover.png';
import showImg from '../../assets/images/show.png';
import showhoverImg from '../../assets/images/showhover.png';
import delete_liImg from '../../assets/images/delete_li.png';
import backgroundImg from '../../assets/images/background.png';
import deleteImg from '../../assets/images/delete.png';
import deletehoverImg from '../../assets/images/deletehover.png';
import saveImg from '../../assets/images/save.png';

interface PitModuleLabelBoxProps {}
const PitModuleLabelBox: FC<PitModuleLabelBoxProps> = () => {
  let [isIntersect, setisIntersect] = useState(false);
  let [changeName, setchangeName] = useState('');
  let [nameChecked] = useState([
    '',
    '请先选择标注位置！',
    '标签名称不能为空！',
  ]);
  let [check, setcheck] = useState(0);
  let [roaming] = useState([]);
  let [isShow] = useState(false);
  let [addIndex] = useState(-1);
  let [clickIndex] = useState(-1);
  let [show] = useState(['显示', '隐藏']);
  useEffect(() => {
    // f (oV !== null && !nV) {
    //   this.check = 2;
    // } else {
    //   this.check = 0;
    // }
    !changeName && setcheck(2);
    changeName && setcheck(0);
  }, [changeName]);
  const _setisIntersect = (value: boolean) => {
    setisIntersect(value);
  };
  const _setchangeName = (e: any) => {
    setchangeName(e.target.value);
  };
  const openLabel = () => {};
  const hideLabel = () => {};
  const displayLabel = () => {};
  const saveLabel = () => {};
  const clickLabel = (index: number) => {
    console.log(index);
  };
  const changeHideItemLabel = (id: string | number) => {
    console.log(id);
  };
  const deleteLabel = (id: string | number) => {
    console.log(id);
  };
  const clearLabel = () => {};
  const addLabel = () => {};
  const handleClose = () => {};
  const roamingNode = roaming.map((item: any, index: number) => {
    return (
      <li
        className={`label-value ${index === addIndex ? 'added' : ''}`}
        onClick={() => clickLabel(index)}
        key={index}
      >
        <span className="label-number"> {index + 1} </span>
        <span className="label-name" title={item.name}>
          {item.name}
        </span>
        {index === clickIndex || index === addIndex ? (
          <span
            className="showBox"
            v-if=""
            onClick={() => changeHideItemLabel(item.id)}
          >
            <img
              className="hideImg"
              v-if="item.isShow"
              title={show[1]}
              src={hideImg}
            />
            <img
              className="hideImgHover"
              v-if="item.isShow"
              title={show[1]}
              src={hidehoverImg}
            />
            <img
              className="showImg"
              v-if="!item.isShow"
              title={show[0]}
              src={showImg}
            />
            <img
              className="showImgHover"
              v-if="!item.isShow"
              title={show[0]}
              src={showhoverImg}
            />
          </span>
        ) : (
          ''
        )}
        {index === clickIndex || index === addIndex ? (
          <img
            className="delete"
            title="删除"
            src={delete_liImg}
            onClick={() => deleteLabel(item.id)}
          />
        ) : (
          ''
        )}
      </li>
    );
  });
  return (
    <div className="pit-label">
      {!isShow ? (
        <div className="pit-label-basic">
          <div className="label-title">
            <div className="label-fuc" onClick={openLabel}>
              <img className="img" src={addImg} />
              <div className="text">添加标签</div>
            </div>
            <div className="label-fuc" onClick={hideLabel}>
              <img className="img" src={hidehoverImg} />
              <div className="text">隐藏</div>
            </div>
            <div className="label-fuc" onClick={displayLabel}>
              <img className="img" src={showhoverImg} />
              <div className="text">显示</div>
            </div>
            <div className="label-fuc" onClick={saveLabel}>
              <img className="img" src={saveImg} />
              <div className="text">保存</div>
            </div>
          </div>
          <div className="label-rangeBox">
            <div className="background">
              {!isShow && roaming.length <= 0 ? (
                <img
                  v-if=""
                  className="background-svg"
                  onClick={openLabel}
                  src={backgroundImg}
                />
              ) : (
                ''
              )}
              {!isShow && roaming.length <= 0 ? (
                <div className="background-text">请添加标签</div>
              ) : (
                ''
              )}
            </div>

            {isShow || roaming.length > 0 ? (
              <div className="label-main" v-if="">
                <ul className="label-list">{roamingNode}</ul>
              </div>
            ) : (
              ''
            )}
          </div>
          <div className="label-delete" onClick={clearLabel}>
            <img className="label-delete-svg" src={deleteImg} alt="" />
            <img
              className="label-delete-svg_hover"
              src={deletehoverImg}
              alt=""
            />
            <span className="label-delete-text"> 删除全部 </span>
          </div>
        </div>
      ) : (
        ''
      )}
      {isShow ? (
        <div className="pit-label-add">
          <div className="add-tips">
            <div>是否标记标签位置</div>
            <PitBimwinSwitchCheckBox
              value={isIntersect}
              onChange={_setisIntersect}
            ></PitBimwinSwitchCheckBox>
          </div>
          <div className="add-input">
            <div className="labelName">标签名称</div>
            <div className="backg">
              <textarea
                className="labelInput"
                value={changeName}
                onChange={_setchangeName}
                placeholder="请输入名称"
              ></textarea>
            </div>
          </div>
          <div className="add-sure">
            {isShow ? <div className="warning">{nameChecked[check]}</div> : ''}
            <div className="button">
              <div className="sure-basic OK" onClick={addLabel}>
                确定
              </div>
              <div className="sure-basic NOOK" onClick={handleClose}>
                取消
              </div>
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};
export default PitModuleLabelBox;
